import React from 'react';

import { NO_RESULTS_IMAGE } from './constants';

const GraphicsSearchPageEmpty = () => {
  return (
    <p className="m-0 flex w-full flex-col items-center gap-32 font-suisse-works text-headline-xxs md:flex-row md:justify-between md:text-headline-sm">
      <span className="block w-full flex-shrink-0 text-center md:max-w-[480px] md:text-left">
        Sorry, we couldn’t find any charts matching that search.
      </span>
      <img
        className="w-[80%] min-w-0 max-w-[480px] object-contain md:max-w-[600px]"
        role="presentation"
        src={NO_RESULTS_IMAGE}
      />
    </p>
  );
};

export default GraphicsSearchPageEmpty;
